import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { GalleryStaffService } from 'src/app/Services/gallery-staff.service';
import { NotificationsService } from 'src/app/Services/shared/notifications.service';
import { NotificationTypes } from 'src/app/app.enums';
import { PermissionTree, Permissions, SaveGalleryStaffRequest } from 'src/app/models/staff.model';
import { ConfirmationService, SelectItem, TreeNode, } from "primeng/api";
import { AuthConfig, AuthService } from 'src/app/Services/auth.service';
import { PermissionService } from 'src/app/Services/permission.service';
import { GalleryStaffRoleEnum } from 'src/app/enums/gallery-event.enums';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'app-gallery-staff',
    templateUrl: './gallery-staff.component.html',
    styleUrls: ['./gallery-staff.component.css'],
    inputs: ['galleryId'],
    standalone: false
})
export class GalleryStaffComponent implements OnInit {
  public staffFormsData: SaveGalleryStaffRequest = {} as SaveGalleryStaffRequest;
  public Staff: SaveGalleryStaffRequest[] = [];
  public staffLoading: boolean = false;
  public staffDailogVisible: boolean = false;
  public isPermissionDailogVisible: boolean = false;
  public isEditMode: boolean = false;
  public galleryId?: string;
  public authConfig: AuthConfig = {};
  public permission: PermissionTree[] = [];
  public selectedPermissionTds: string[]= [];
  public gallerStaffId!: string;
  public isPermissionLoaded: boolean = false;
  public trueIsSelected: boolean = false;
  public selectedPermission: TreeNode<any> | TreeNode<any>[] | null | undefined

  // Staff Role properties
  public staffRoleOptions: SelectItem[] = [
    { label: 'Judge', value: GalleryStaffRoleEnum.Judge },
    { label: 'Curator', value: GalleryStaffRoleEnum.Curator },
    { label: 'Other', value: GalleryStaffRoleEnum.Other }
  ];
  public GalleryStaffRoleEnum = GalleryStaffRoleEnum;
  public selectedStaffRole: number | null = null;
  public customPosition: string = '';

  // Output event when staff is saved (for parent components to refresh their lists)
  @Output() onStaffSaved = new EventEmitter<void>();

  constructor(private galleryStaffService: GalleryStaffService, private ngxSpinnerService: NgxSpinnerService, private notificationsService: NotificationsService, private confirmationService: ConfirmationService, private authService: AuthService, private permissionService: PermissionService, private transloco: TranslocoService) {

  }
  ngOnInit(): void {
    this.authConfig = this.authService.getAuthConfig();
    if (this.authConfig.IsSuperAdmin || this.authConfig.IsAdministrator || this.authConfig.IsGallery) {
      console.log("galleryId", this.galleryId);

      this.getAllGalleryStaff();
      // this.trueIsSelected = false;
      this.getAllPermissions()
    }
    
  }

  public loadingPermissions: boolean = false;

  public getAllPermissions() {
    this.loadingPermissions = true;
    this.permissionService.getAllPermissions().subscribe((permissions: SelectItem[]) => {
      console.log(permissions)
      const parentNode: PermissionTree = {
        label: 'All Permissions',
        expanded: true,
        children: permissions.map(p=>{
          return{
            label:p.label,
            value:p.value,
          }
        })
      };
      this.permission = [parentNode];
      this.loadingPermissions = false;
      console.log("permissions", this.permission)
      this.ngxSpinnerService.hide();
    }, (error) => { this.handleRequestError(error); this.loadingPermissions = false; });
  }

  public onselectedPermissionIds(event: any) {
    if (event.node.value) {
      // Ensure selectedPermissionTds is an array
      if (!Array.isArray(this.selectedPermissionTds)) {
        this.selectedPermissionTds = [];
      }
      // Push the single ID into the array
      this.selectedPermissionTds.push(event.node.value);
      console.log("selectedPermissionTds", this.selectedPermissionTds);
    }
  }


  public savePermissions() {
    this.ngxSpinnerService.show();
    this.permissionService.savePermissions(this.gallerStaffId, this.selectedPermissionTds).subscribe((response) => {
      this.ngxSpinnerService.hide();
      console.log("responce", response.ResponseMessage)
      if (response.Success) {
        this.notificationsService.showNotification(
          this.transloco.translate('galleryStaff.successTitle'),
          response.ResponseMessage,
          NotificationTypes.Success
        );
        this.getSelectedPermissions(this.gallerStaffId)
        this.isPermissionDailogVisible = false;
      } else {
        this.notificationsService.showNotification(
          this.transloco.translate('galleryStaff.errorTitle'),
          response.ResponseMessage,
          NotificationTypes.Error
        );
      }
    },
      (error) => {
        this.handleRequestError(error);
      })
  }
  public showDailog() {
    this.staffDailogVisible = true
    this.isEditMode = false;
  }

  public closeDialog() {
    this.staffDailogVisible = false;
    this.staffFormsData = {} as SaveGalleryStaffRequest;
    this.selectedStaffRole = null;
    this.customPosition = '';
  }

  public onCancel() {
    this.staffDailogVisible = false
  }

  private getAllGalleryStaff() {
    this.ngxSpinnerService.show();
    this.galleryStaffService.FetchGalleryStaff(this.galleryId!).subscribe((Staff: SaveGalleryStaffRequest[]) => {
      this.Staff = Staff;
      console.log('Staff', this.Staff);

      this.staffLoading = false;
      this.ngxSpinnerService.hide();
    },
      (error) => {
        this.handleRequestError(error);
      }
    );
  }

  public saveGalleryStaff() {
    this.ngxSpinnerService.show();
    this.staffFormsData.GalleryId = this.galleryId;
    // Set Name field from FirstName for consistency
    if (this.staffFormsData.FirstName) {
      this.staffFormsData.Name = this.staffFormsData.FirstName;
    }

    // Set StaffRole and GalleryStaffPosition based on selected role
    this.staffFormsData.StaffRole = this.selectedStaffRole || undefined;
    if (this.selectedStaffRole === GalleryStaffRoleEnum.Judge) {
      this.staffFormsData.GalleryStaffPosition = 'Judge';
    } else if (this.selectedStaffRole === GalleryStaffRoleEnum.Curator) {
      this.staffFormsData.GalleryStaffPosition = 'Curator';
    } else if (this.selectedStaffRole === GalleryStaffRoleEnum.Other) {
      this.staffFormsData.GalleryStaffPosition = this.customPosition || 'Other';
    }

    this.galleryStaffService.SaveGalleryStaff(this.staffFormsData).subscribe((response) => {
      this.ngxSpinnerService.hide();
      console.log("saveGalleryStaff", response.ResponseData)
      if (response.Success) {
        this.notificationsService.showNotification(
          this.transloco.translate('galleryStaff.successTitle'),
          response.ResponseMessage,
          NotificationTypes.Success
        );
        this.getAllGalleryStaff();
        this.onStaffSaved.emit(); // Notify parent to refresh staff lists
        this.staffDailogVisible = false;
        this.staffFormsData = {} as SaveGalleryStaffRequest;
        this.selectedStaffRole = null;
        this.customPosition = '';
      } else {
        this.notificationsService.showNotification(
          this.transloco.translate('galleryStaff.errorTitle'),
          response.ResponseMessage,
          NotificationTypes.Error
        );
      }
    },
      (error) => {
        this.handleRequestError(error);
      }
    );
  }

  public editGalleryStaff(id: string) {
    this.staffDailogVisible = true;
    var staff = this.Staff.find(p => p.Id == id);
    if (staff) {
      // Create a copy to avoid direct mutation
      this.staffFormsData = { ...staff };
      // Ensure FirstName is populated from Name if needed
      if (!this.staffFormsData.FirstName && this.staffFormsData.Name) {
        this.staffFormsData.FirstName = this.staffFormsData.Name;
      }

      // Populate selectedStaffRole and customPosition based on existing data
      if (staff.StaffRole) {
        this.selectedStaffRole = staff.StaffRole;
        if (staff.StaffRole === GalleryStaffRoleEnum.Other) {
          this.customPosition = staff.GalleryStaffPosition || '';
        } else {
          this.customPosition = '';
        }
      } else if (staff.GalleryStaffPosition) {
        // Determine role from position string if StaffRole is not set
        const position = staff.GalleryStaffPosition.toLowerCase();
        if (position === 'judge') {
          this.selectedStaffRole = GalleryStaffRoleEnum.Judge;
          this.customPosition = '';
        } else if (position === 'curator') {
          this.selectedStaffRole = GalleryStaffRoleEnum.Curator;
          this.customPosition = '';
        } else {
          this.selectedStaffRole = GalleryStaffRoleEnum.Other;
          this.customPosition = staff.GalleryStaffPosition;
        }
      } else {
        this.selectedStaffRole = null;
        this.customPosition = '';
      }
    }
    this.isEditMode = true;
  }

  public deleteGalleryStaff(Id: string) {
    const staff = this.Staff.find(s => s.Id === Id);
    const staffName = staff?.Name || staff?.FirstName || this.transloco.translate('galleryStaff.thisStaffMember');

    this.confirmationService.confirm({
      message: this.transloco.translate('galleryStaff.deleteStaffConfirm', { name: staffName }),
      header: this.transloco.translate('galleryStaff.deleteConfirmationHeader'),
      icon: 'pi pi-exclamation-triangle',
      acceptButtonStyleClass: 'p-button-danger',
      accept: () => {
        this.ngxSpinnerService.show();
        this.galleryStaffService.DeleteGalleryStaff(Id).subscribe((response) => {
          this.ngxSpinnerService.hide();
          if (response.Success) {
            this.notificationsService.showNotification(
              this.transloco.translate('galleryStaff.successTitle'),
              response.ResponseMessage,
              NotificationTypes.Success
            );
            var index = this.Staff.findIndex((staff) => staff.Id == Id);
            if (index >= 0) {
              this.Staff.splice(index, 1);
            }
          } else {
            this.notificationsService.showNotification(
              this.transloco.translate('galleryStaff.errorTitle'),
              response.ResponseMessage,
              NotificationTypes.Error
            );
          }
        },
          (error) => {
            this.handleRequestError(error);
          }
        );
      },
    });
  }

  private handleRequestError(error: any) {
    this.staffLoading = false;
    console.error(error);
    this.ngxSpinnerService.hide();
  }

  public showPermissionDailog(id: string) {
    this.isPermissionDailogVisible = true
    this.gallerStaffId = id;
    //TODO: Commented out temporary
    this.getSelectedPermissions(this.gallerStaffId)
  }

  // private getSelectedPermissions(gallerStaffId: string) {
  //   this.ngxSpinnerService.show();
  //   this.isPermissionLoaded = true
  //   this.permissionService.getAllPermissionByStaffId(gallerStaffId).subscribe((selectedpermission: Permissions[]) => {
  //     console.log(selectedpermission.map(p => p.PermissionId))
  //     if (selectedpermission.length === 0) {

  //       this.getAllPermissions();
  //     } else {
  //     const parentNode: PermissionTree = {
  //       label: 'Permissions',
  //       expanded: true,
  //       children: selectedpermission.map(p => {
  //         return {
  //           label: p.Permission,
  //           value: p.PermissionId,
  //         }
  //       })
  //       // childern: [{
  //       //     label:selectedpermission.map(p=>p.label),
  //       //     value:selectedpermission.map(p=>p.value)
  //       //   }]
  //     };
  //     console.log("parentnode", parentNode)
  //     this.permission = [parentNode];
  //     this.isPermissionLoaded = false
  //     console.log("permissions", this.permission)
  //     this.ngxSpinnerService.hide();
  //   }
  //   },
  //     (error) => {
  //       this.handleRequestError(error);
  //     })
  // }

  private getSelectedPermissions(gallerStaffId: string) {
    this.ngxSpinnerService.show();
    this.isPermissionLoaded = true;
    this.permissionService.getAllPermissionByStaffId(gallerStaffId).subscribe((selectedpermission: Permissions[]) => {
      console.log(selectedpermission.map(p => p.PermissionId));
      this.selectedPermissionTds = selectedpermission.map(p => p.PermissionId); // Update selectedPermissionTds here
      console.log("this.selectedPermissionTds", this.selectedPermissionTds);

      // Get all permissions
      this.permissionService.getAllPermissions().subscribe((allPermissions: SelectItem[]) => {
        const unselectedPermissions = allPermissions.filter(permission => !this.selectedPermissionTds.includes(permission.value));

        const selectedPermissionsTree = selectedpermission.map(p => {
          return {
            label: p.Permission,
            value: p.PermissionId,
          };
        });
        const unselectedPermissionsTree = unselectedPermissions.map(p => {
          return {
            label: p.label,
            value: p.value,
          };
        });
        
        this.selectedPermission = selectedPermissionsTree;
        console.log(selectedpermission)
        const parentNode: PermissionTree = {
          label: 'Permissions',
          expanded: true,
          children: [...selectedPermissionsTree, ...unselectedPermissionsTree]
        };
        console.log("selected", selectedPermissionsTree);
        console.log("unSelected", unselectedPermissionsTree);
        this.permission = [parentNode];
        this.selectedPermission = selectedPermissionsTree;
        console.log(selectedpermission)
        this.isPermissionLoaded = false;
        console.log("permissions", this.permission);
        this.ngxSpinnerService.hide();
      });
    }, (error) => {
      this.handleRequestError(error);
    });
}



  public onClosePermissionDailog() {
    this.isPermissionDailogVisible = false
  }

  /**
   * Get staff role label for display
   */
  public getStaffRoleLabel(role: number | undefined): string {
    if (!role) return 'Not Set';
    if (role === GalleryStaffRoleEnum.Judge) return 'Judge';
    if (role === GalleryStaffRoleEnum.Curator) return 'Curator';
    return 'Other';
  }

  /**
   * Handle role dropdown change
   */
  public onRoleChange(): void {
    // Clear custom position when switching away from "Other"
    if (this.selectedStaffRole !== GalleryStaffRoleEnum.Other) {
      this.customPosition = '';
    }
  }

}
